import { Avatar, Button, Flex, Space, Card, Typography, Rate, Divider } from 'antd'
import { useChannels } from '@entities/channel'
import React, { useMemo } from 'react'
import useMobileView from '@shared/hooks/isMobile'
import { InternetRecourceType } from '@entities/channel/model/types'

const { Title, Text } = Typography

export const Seller = () => {
    const isMobile = useMobileView()

    const { channelDetails } = useChannels()

    const isChannel = useMemo(() => channelDetails?.type === InternetRecourceType.channel, [channelDetails?.type])

    return (
        <Flex gap={31} vertical={isMobile}>
            {/*{'лево'}*/}
            <Flex>
                <Card
                    style={{ backgroundColor: '#fff', width: isMobile ? 'auto' : 520 }}
                    bodyStyle={{ padding: '10px' }}
                >
                    <Flex gap={20} justify={'space-between'}>
                        <Space size={20} align="start">
                            <Avatar
                                shape="circle"
                                size={100}
                                src={isChannel ? channelDetails?.photoUrl : `${channelDetails?.url}/favicon.ico`}
                            />
                            <Flex vertical={true} gap={6} style={{ width: '100%' }}>
                                <Flex justify={'space-between'} style={{ width: '100%' }}>
                                    <Title level={4} style={{ margin: 0, cursor: 'pointer' }}>
                                        <Space>{channelDetails?.name}</Space>
                                    </Title>
                                </Flex>
                                <Text strong> {channelDetails?.username}</Text>
                                <Text strong>Рейтинг на бирже </Text>
                                <Flex gap={'small'} wrap={'nowrap'} align={'center'}>
                                    <Text style={{ fontSize: 36, fontWeight: 600 }}>{2.5}</Text>
                                    <Rate allowHalf defaultValue={2.5} />
                                </Flex>
                            </Flex>
                        </Space>
                        {/*<Flex gap={'small'}>*/}
                        {/*    <Button size={'small'} type={'default'}>*/}
                        {/*        Telegaplan User*/}
                        {/*    </Button>*/}
                        {/*    <Button size={'small'} type={'default'}>*/}
                        {/*        Pro*/}
                        {/*    </Button>*/}
                        {/*</Flex>*/}
                    </Flex>
                    <Divider style={{ margin: '10px 0' }} />
                    <Flex vertical>
                        <Text style={{ fontSize: 20, fontWeight: 700 }}>Активность</Text>
                        <Text>Выставил первый канал 07 нояб. 2022 г.</Text>
                        <Text>Последний раз был 06.04.2025 (в 12:01)</Text>
                        <Text>Успешных сделок: 33</Text>
                        <Text style={{ fontSize: 20, fontWeight: 700, marginTop: 37 }}>
                            Рейтинг и активация (делаем позже)
                        </Text>
                        <Text>Слагаемые рейтинга (+440)</Text>
                        <Text>Слагаемые рейтинга (+440)</Text>
                        <Text>Слагаемые рейтинга (+440)</Text>
                        <Text>Слагаемые рейтинга (+440)</Text>
                        <Text>Слагаемые рейтинга (+440)</Text>
                        <Text>Слагаемые рейтинга (+440)</Text>
                        <Text>Слагаемые рейтинга (+440)</Text>
                        <Text style={{ fontSize: 20, fontWeight: 700 }}>Qiwi: привязан(а) (делаем позже)</Text>{' '}
                        <Text style={{ fontSize: 20, fontWeight: 700 }}>Qiwi: привязан(а) (делаем позже)</Text>{' '}
                        <Text style={{ fontSize: 20, fontWeight: 700 }}>Qiwi: привязан(а) (делаем позже)</Text>
                    </Flex>
                </Card>
            </Flex>
            {/*{'право'}*/}
            <Flex style={{ width: '100%' }}>
                <Card style={{ backgroundColor: '#fff', width: '100%' }} bodyStyle={{ padding: '20px' }}>
                    <Text style={{ fontSize: 24, fontWeight: 400 }}>12 отзывов о работе на бирже Telegaplan</Text>
                    <Divider style={{ margin: '10px 0' }} />
                    {Array.from({ length: 4 }).map((_, i) => (
                        <Card bodyStyle={{ padding: '15px' }} style={{ marginTop: 20 }}>
                            <Flex justify={'space-between'} align={'center'} style={{ marginBottom: 15 }}>
                                <Button type={'default'}>Покупатель</Button>
                                <Rate allowHalf defaultValue={2.5} />
                            </Flex>
                            <Flex vertical>
                                <Text>300000 руб</Text>
                                <Text>1 мес. назад</Text>
                                <Text>
                                    Сделка прошла отлично, продавец подробно отвечает на все интересующие вопросы.
                                    Спасибо!
                                </Text>
                            </Flex>
                        </Card>
                    ))}
                </Card>
            </Flex>
        </Flex>
    )
}
